var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("storage::out-stock::add_sku_add"),
        visible: _vm.skuVisible,
        width: "690px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.skuVisible = $event
        },
        closed: function ($event) {
          _vm.tempList = []
        },
      },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticStyle: {
                "border-right": "1px solid #dcdfe6",
                padding: "0 24px",
              },
              attrs: { span: 14 },
            },
            [
              _c(
                "div",
                { staticClass: "search-wrap" },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "80%" },
                      attrs: {
                        placeholder: _vm.$t("storage::out-stock::add_input"),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.keyword,
                        callback: function ($$v) {
                          _vm.keyword = $$v
                        },
                        expression: "keyword",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "110px" },
                          attrs: {
                            slot: "prepend",
                            placeholder: _vm.$t(
                              "storage::out-stock::add_select"
                            ),
                          },
                          slot: "prepend",
                          model: {
                            value: _vm.selectType,
                            callback: function ($$v) {
                              _vm.selectType = $$v
                            },
                            expression: "selectType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "SKU", value: "sku" },
                          }),
                          _c("el-option", {
                            attrs: { label: "SPU", value: "spu" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-right": "8px", color: "#666" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("system::common::btn::selecAll"))
                          ),
                        ]
                      ),
                      _c("el-checkbox", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.searchList.length,
                            expression: "searchList.length",
                          },
                        ],
                        attrs: { value: _vm.checkSelectAll },
                        on: { change: _vm.selectAll },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", [
                _c(
                  "ul",
                  { staticClass: "ul-list" },
                  _vm._l(_vm.searchList, function (item) {
                    return _c(
                      "li",
                      { key: item.skuId, staticClass: "sku-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sku-title",
                            staticStyle: { width: "85%" },
                          },
                          [
                            _c("ZImg", {
                              staticClass: "image",
                              attrs: { src: item.img },
                            }),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "10px" } },
                              [
                                _c("p", [_vm._v(_vm._s(item.skuId))]),
                                _c(
                                  "p",
                                  {
                                    staticClass: "one-line",
                                    staticStyle: { width: "240px" },
                                  },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("el-checkbox", {
                          attrs: {
                            value: _vm.list.some(function (i) {
                              return i.skuId === item.skuId
                            }),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.chooseItem(item)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
          _c("el-col", { attrs: { span: 10 } }, [
            _c("div", [
              _c(
                "ul",
                {
                  staticClass: "ul-list",
                  staticStyle: { height: "410px", padding: "0 24px" },
                },
                _vm._l(_vm.list, function (item) {
                  return _c(
                    "li",
                    { key: item.skuId, staticClass: "sku-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "sku-title" },
                        [
                          _c("ZImg", {
                            staticClass: "image",
                            attrs: { src: item.img },
                          }),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "10px" } },
                            [
                              _c("p", [_vm._v(_vm._s(item.skuId))]),
                              _c(
                                "p",
                                {
                                  staticClass: "one-line",
                                  staticStyle: { width: "140px" },
                                },
                                [_vm._v(" " + _vm._s(item.title) + " ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("i", {
                        staticClass: "el-icon-circle-close",
                        staticStyle: { "font-size": "20px", color: "#999" },
                        on: {
                          click: function ($event) {
                            return _vm.remove(item)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.skuVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("storage::out-stock::add_cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addSku } },
            [_vm._v(_vm._s(_vm.$t("storage::out-stock::add_add")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }